export function removeUndefined<Type extends object>(obj: Type): Type {
  const newObj: Type = { ...obj };
  Object.keys(newObj).forEach((x) => {
    const value = newObj[x as keyof typeof obj];
    if (value && typeof value === 'object') {
      removeUndefined(value);
    } else if (value === undefined || value === null || value === '') {
      delete newObj[x as keyof typeof obj];
    }
  });
  return newObj;
}
